var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTaskSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.5,
    r: 6,
    stroke: "#00B292"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.06791 6.76551C3.87265 6.57024 3.55606 6.57024 3.3608 6.76551C3.16554 6.96077 3.16554 7.27735 3.3608 7.47261L4.06791 6.76551ZM9.32981 5.30595C9.52508 5.11068 9.52508 4.7941 9.32981 4.59884C9.13455 4.40358 8.81797 4.40358 8.62271 4.59884L9.32981 5.30595ZM5.12055 8.52526L4.767 8.87881L5.12055 8.52526ZM3.3608 7.47261L4.767 8.87881L5.47411 8.1717L4.06791 6.76551L3.3608 7.47261ZM5.75695 8.87881L9.32981 5.30595L8.62271 4.59884L5.04984 8.1717L5.75695 8.87881ZM4.767 8.87881C5.04037 9.15218 5.48358 9.15218 5.75695 8.87881L5.04984 8.1717C5.167 8.05455 5.35695 8.05455 5.47411 8.1717L4.767 8.87881Z",
    fill: "#00B292"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTaskSmall);
export default __webpack_public_path__ + "static/media/icon-task-small.6801df39.svg";
export { ForwardRef as ReactComponent };